import { Account, Cred, Resource } from '.';

export enum AuraSource {
  USER = 'USER',
  SYSTEM = 'SYSTEM',
}

export enum AuraStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export class AuraCreateParams {
  name: string;
  accountId: string;
  type: AuraSource;

  constructor(name: string, accountId: string, type: AuraSource = AuraSource.USER) {
    this.name = name;
    this.accountId = accountId;
    this.type = type;
  }
}

export class Aura {
  id: string;
  name: string;
  createdAt?: Date;
  createdBy: Account;
  type: AuraSource;
  status: AuraStatus;

  constructor(json: any) {
    this.id = json.id || json._id;
    this.name = json.name;
    this.createdAt = json.createdAt && new Date(json.createdAt);
    this.createdBy = json.createdBy && new Account(json.createdBy);
    this.type = json.type || AuraSource.USER;
    this.status = json.status || AuraStatus.ACTIVE;
  }
}

export enum ElevatorPitchStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export class ElevatorPitch {
  account: Account;
  introScript: string;
  cred: Cred;
  resource?: Resource;
  status: ElevatorPitchStatus;

  constructor(json: any) {
    this.account = json.account && new Account(json.account);
    this.introScript = json.introScript;
    this.cred = json.cred && new Cred(json.cred);
    this.resource = json.resource ? new Resource(json.resource) : undefined;
    this.status = json.status;
  }
}
